import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BadgeDollarSign } from "lucide-react";

export default function ResellerTeaser() {
  return (
    <section className="max-w-[1500px] mx-auto px-6 mt-20">
      <Link
        to="/revenda"
        data-testid="home-revenda-teaser"
        className="group relative overflow-hidden flex flex-col md:flex-row md:items-center gap-6 rounded-3xl border border-brand-2/30 bg-surface/70 p-8 md:p-10 hover:border-brand-2/60 transition-colors"
      >
        <div className="absolute -left-20 -top-20 w-80 h-80 rounded-full bg-brand/20 blur-[110px] pointer-events-none" />
        <span className="relative w-16 h-16 shrink-0 rounded-2xl bg-brand-gradient flex items-center justify-center shadow-lg shadow-brand/30">
          <BadgeDollarSign className="w-8 h-8 text-white" />
        </span>
        <div className="relative flex-1">
          <p className="text-xs font-bold uppercase tracking-[0.3em] brand-gradient-text">Renda extra</p>
          <h2 className="mt-2 text-2xl md:text-3xl font-extrabold">Seja um Revendedor MasterX</h2>
          <p className="mt-2 text-silver/75 max-w-2xl">Painel próprio, créditos que não expiram e alta margem de lucro. Comece hoje mesmo.</p>
        </div>
        <span className="relative inline-flex items-center gap-2 self-start md:self-center px-6 py-3 rounded-full bg-brand-gradient text-white font-bold shadow-lg shadow-brand/30">
          Conhecer a revenda <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
        </span>
      </Link>
    </section>
  );
}
